import { css } from '@emotion/css';

const styles = {
  container: css`
    display: none;

    @media print {
      display: block;
    }
  `,
  flyer: css`
    @media print {
      object-fit: contain !important;
    }
  `,
};

export default styles;
